import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import Image from "next/image";
import bannerTwp from "/public/twp-banner.png";

/**
 * TWP（Tocca Working Platform）への導線バナー。
 *
 * トップページと /service の両方から使うため、レイアウト固有のクラスは
 * className で受け取る（/service はグリッドの中に置くため col-span が必要）。
 *
 * 文言は「α版提供開始」から正式提供・無料枠ありへ更新（2026-08）。
 * 画像の上に載る文字はHTML側で描いているので、背景画像を差し替えても文言は崩れない。
 */
export const TwpBanner = ({ className }) => {
  return (
    <div
      className={clsx(
        "relative mx-auto box-border w-full max-w-7xl overflow-hidden",
        className
      )}
    >
      <a
        href="https://twp-saas.tocca.systems/"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative block transition-opacity hover:opacity-90"
      >
        <div className="relative aspect-[1408/768] w-full sm:aspect-[16/9]">
          <Image
            src={bannerTwp}
            alt="TWP（Tocca Working Platform） - AIエージェントが業務をつなぐ統合ワーキングプラットフォーム"
            quality={80}
            layout="fill"
            objectFit="cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-nvy/80 via-nvy/50 to-transparent" />
          <div className="absolute inset-0 flex flex-col justify-center px-6 sm:px-8 md:px-12 lg:px-16">
            <div className="max-w-xl">
              <h6 className="mb-2 text-sm font-bold text-pri md:mb-4 md:text-md">
                TWP（Tocca Working Platform）
              </h6>
              <h3 className="mb-2 font-bold text-white fluid-text-[18px,32px] md:mb-4">
                AIエージェントが業務をつなぐ統合プラットフォーム
              </h3>
              <p className="mb-4 text-white/90 fluid-text-[12px,16px] md:mb-6">
                勤怠・プロジェクト・営業・人材・ナレッジ・AIまで。
                <br className="hidden sm:block" />
                登録するだけで主要機能の無料枠を、その日からご利用いただけます。
              </p>
              <span className="inline-flex items-center gap-2 rounded-md bg-pri px-4 py-2 text-sm font-bold text-white transition-colors group-hover:bg-pri/80 md:px-6 md:py-3 md:text-base">
                TWPのサイトへ
                <FontAwesomeIcon
                  icon={faArrowUpRightFromSquare}
                  className="text-xs"
                />
              </span>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};
